import AppList, {AppListConfig} from "../../../../../components/layout/list";
import {OrganizationUnitMember, OrganizationUnitMemberRestControllerApiFactory,} from "arteco-api-client-ts";
import React from "react";
import {useApiManager} from "../../../../../components/utils/api";
import {useParams} from "react-router-dom";
import {usePerson} from "../index";
import {parsePathId} from "../../../../../components/form/form_utils";
import {TableCell, Typography} from "@mui/material";
import {dateToString} from "../../../../../components/utils/dates";
import {SoftChip} from "../../../../../components/kit";
import {personName} from "../header";

export const UnitMemberListPage = () => {
	const params = useParams();
	const apiManager = useApiManager();


	const personId = parsePathId(params, "personId");
	const [person, setPerson] = usePerson(personId);

	const salaryCtrl = apiManager.factory(OrganizationUnitMemberRestControllerApiFactory);


	const listConfig: AppListConfig<OrganizationUnitMember> = {
		title: "Unidad organizativa de " + personName(person),
		onClick: "/app/admin/employee/person/" + person?.id + "/organization-unit",
		headers: [
			{title: "Desde"},
			{title: "Unidad"},
			{title: "Persona"},
		],
		decorator: (bean: OrganizationUnitMember) =>
			<>
				<TableCell><Typography variant="body2" fontWeight={600}>{dateToString(bean.startDate)}</Typography></TableCell>
				<TableCell>{bean.unit?.name ? <SoftChip tone="info" label={bean.unit.name}/> : "—"}</TableCell>
				<TableCell>{personName(bean.person)}</TableCell>
			</>,
		supplier: async (currentPage, size, term, showDismissed) => {
			if (personId) {
				return salaryCtrl.pageOrganizationUnitMember(
					personId,
					currentPage,
					size,
					undefined,
					undefined,
					term,
					showDismissed
				);
			} else {
				throw new Error("PersonId is null");
			}
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};